//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import ClientId from '@models/ClientId';

export const EdgeContentType = {
  Review: 'REVIEW',
  Visual: 'VISUAL',
} as const;

export type EdgeContentType =
  (typeof EdgeContentType)[keyof typeof EdgeContentType];

export interface BazaarvoiceDestinationsRequest {
  edgeContentTypes: EdgeContentType[];
  sourceClientId: ClientId;
}

export interface BazaarvoiceDestinationClient {
  id: ClientId;
  name: string;
  numItemsShared: number;
  productsWithNativeOrSyndicatedReviews?: number;
  totalReviews?: number;
  totalSyndicatedReviews?: number;
}

export interface BazaarvoiceDestinationsForSourceResponse {
  clients: BazaarvoiceDestinationClient[];
}
